// extracted by mini-css-extract-plugin
export default {"acceptTermsAlert":"AcceptTermsModal-module__acceptTermsAlert--WitjW","buttonContainer":"AcceptTermsModal-module__buttonContainer--AaPnW"};